import { render, staticRenderFns } from "./HbCommunication.vue?vue&type=template&id=f6a058a4&scoped=true&"
import script from "./HbCommunication.vue?vue&type=script&lang=js&"
export * from "./HbCommunication.vue?vue&type=script&lang=js&"
import style0 from "./HbCommunication.vue?vue&type=style&index=0&id=f6a058a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a058a4",
  null
  
)

export default component.exports